import { render, staticRenderFns } from "./ShowChildrenDialog.vue?vue&type=template&id=45be9c3a"
import script from "./ShowChildrenDialog.vue?vue&type=script&lang=js"
export * from "./ShowChildrenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports